var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrnMapZoomIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BRN---Mapping-the-Network---Instructions",
    transform: "translate(-18.000000, -1014.000000)",
    stroke: "#000000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(18.000000, 1014.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "zoom-in",
    fill: "#FFFFFF",
    x: 1.5,
    y: 1.5,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Expand/White",
    transform: "translate(7.000000, 8.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.715101285,10.5 C3.21097884,9.83333333 6.54431217,9.5 9.28489871,9.5 C12.0254853,9.5 15.3588186,9.5 19.2848987,9.5",
    id: "Agenda-Line-1-Copy-4",
    transform: "translate(9.284899, 10.000000) rotate(90.000000) translate(-9.284899, -10.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.2151013 C3.92608012,10.5484346 7.25941346,10.2151013 10,10.2151013 C12.7405865,10.2151013 16.0739199,10.2151013 20,10.2151013",
    id: "Agenda-Line-1-Copy-4"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrnMapZoomIn);
export default __webpack_public_path__ + "static/media/BRN-Map-Zoom_In.e3a7bee3f10f2073856f57f36dd9ada3.svg";
export { ForwardRef as ReactComponent };